import { queryOptions } from '@tanstack/react-query';
import {
  type ListFlowRunsParams,
  listFlowRunNodes,
  listFlowRuns,
} from '../api/flow-executions';
import { getNodeExecutionOutput } from '../api/getNodeExecutions';

const flowExecutions = {
  runs: (params: ListFlowRunsParams) =>
    queryOptions({
      queryKey: [
        'flowExecutions',
        params.flowId,
        params.page ?? 1,
        params.limit ?? 25,
        params.status ?? 'all',
        params.flowVersionHistoryId === null
          ? 'null'
          : params.flowVersionHistoryId ?? 'any',
      ],
      queryFn: () => listFlowRuns(params),
      enabled: !!params.flowId,
    }),
  runNodes: (flowId: string, execId: string | null) =>
    queryOptions({
      queryKey: ['flowExecutions', 'nodes', flowId, execId],
      queryFn: () => listFlowRunNodes(flowId, execId as string),
      enabled: !!flowId && !!execId,
    }),
  nodeOutput: (id: string | null) =>
    queryOptions({
      queryKey: ['flowExecutions', 'output', id],
      queryFn: () => getNodeExecutionOutput(id as string),
      enabled: !!id,
      staleTime: Infinity,
    }),
};

export { flowExecutions };
